import { InputField } from 'lib/iterable-hook-form';
import { KeyboardEvent } from 'react';
import styled from 'styled-components';
import { INPUT_TEXT_TYPES } from 'ui/inputs';
import { pxToRem } from 'utils/convert';

const StyledInputField = styled(InputField)`
  width: ${pxToRem(80)};

  input {
    width: ${pxToRem(36)};
  }
`;

const preventDecimalInput = (e: KeyboardEvent<HTMLInputElement>) =>
  e.key === '.' && e.preventDefault();

type Props = {
  name: string;
  isReadOnly: boolean;
};

export const THRESHOLD_ID = 'alert-threshold';

export const NumberThresholdField: React.FC<Props> = ({ isReadOnly, name }) => (
  <StyledInputField
    isReadOnly={isReadOnly}
    name={name}
    type={INPUT_TEXT_TYPES.NUMBER}
    onKeyDown={preventDecimalInput}
  />
);

export const PercentageThresholdField: React.FC<Props> = ({ isReadOnly, name }) => (
  <StyledInputField
    data-test={THRESHOLD_ID}
    isReadOnly={isReadOnly}
    name={name}
    Suffix={'%'}
    type={INPUT_TEXT_TYPES.NUMBER}
  />
);

export const FREQUENCY_ID = 'alert-frequency';

export const AlertFrequencyField: React.FC<Props> = ({ isReadOnly, name }) => (
  <StyledInputField
    data-test={FREQUENCY_ID}
    isReadOnly={isReadOnly}
    name={name}
    type={INPUT_TEXT_TYPES.NUMBER}
    onKeyDown={preventDecimalInput}
  />
);
